import { LotResponseWithProxy } from './lot-card-mapper.util';

export type ClosedLotOutcome = Pick<
    LotResponseWithProxy,
    'highBidderId' | 'reserveAmount' | 'currentPrice'
>;

export interface ClosedLotViewer {
    id: string | null | undefined;
    isAdmin: boolean;
}

export function canViewClosedLot(
    lot: ClosedLotOutcome,
    viewer: ClosedLotViewer,
): boolean {
    return viewer.isAdmin || isClosedLotWinner(lot, viewer.id);
}

function isClosedLotWinner(
    lot: ClosedLotOutcome,
    viewerId: string | null | undefined,
): boolean {
    if (!viewerId || lot.highBidderId !== viewerId) {
        return false;
    }
    const reserve: number = Number(lot.reserveAmount ?? 0);
    return reserve <= 0 || Number(lot.currentPrice ?? 0) >= reserve;
}
